import * as React from "react";
import styles from "./styles/Content.module.css";

interface ContentProps {
    children: React.ReactNode;
}

export const Content = ({ children }: ContentProps) => <div className={styles.content}>{children}</div>;
